import React from 'react';
import { MEDIA_CONFIG } from '../data/media';

function Legal() {
  return (
    <div className="min-h-screen bg-black text-white pt-20">
      {/* Hero Section */}
      <div className="relative h-[40vh] flex items-center justify-center overflow-hidden">
        <img
          src={`${MEDIA_CONFIG.paths.backgrounds}/headers/legal-header.jpg`}
          alt="Impressum Header"
          className="absolute w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/60"></div>
        <div className="relative z-10 text-center px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Impressum</h1>
          <p className="text-xl max-w-2xl mx-auto">
            Rechtliche Informationen zu honzamedia
          </p>
        </div>
      </div>
      
      <div className="max-w-4xl mx-auto px-4 py-16">
        <section className="mb-12">
          <h2 className="text-2xl font-bold mb-6">Angaben gemäß § 5 TMG:</h2>
          <div className="space-y-4">
            <div>
              <h3 className="text-xl font-semibold mb-2">Jan Ctvrtnicek - HonzaMedia</h3>
              <p className="text-gray-300">
                Jan Ctvrtnicek<br />
                Detmolder Straße 53<br />
                33813 Oerlinghausen<br />
                Deutschland
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold mb-2">Kontakt:</h3>
              <p className="text-gray-300">
                Telefon: +49 179-4323436<br />
                E-Mail: info@honzamedia.de
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold mb-2">Umsatzsteuer-ID:</h3>
              <p className="text-gray-300">
                Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:<br />
                DE338744155
              </p>
            </div>
          </div>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-bold mb-4">Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV:</h2>
          <p className="text-gray-300">
            Jan Ctvrtnicek<br />
            Detmolder Straße 53<br />
            33813 Oerlinghausen
          </p>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-bold mb-6">Haftungsausschluss:</h2>
          
          <div className="space-y-8">
            <div>
              <h3 className="text-xl font-semibold mb-4">Haftung für Inhalte</h3>
              <p className="text-gray-300">
                Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold mb-4">Haftung für Links</h3>
              <p className="text-gray-300">
                Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold mb-4">Urheberrecht</h3>
              <p className="text-gray-300">
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold mb-4">Streitschlichtung</h3>
              <p className="text-gray-300">
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
                <a 
                  href="https://ec.europa.eu/consumers/odr" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-accent-400 hover:text-accent-300 transition-colors"
                >
                  https://ec.europa.eu/consumers/odr
                </a>
                . Unsere E-Mail-Adresse finden Sie oben im Impressum. Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold mb-4">Bildnachweise</h3>
              <p className="text-gray-300">
                Die auf dieser Website verwendeten Bilder stammen von MotionArray.com sowie von Jakob Owens auf Unsplash. Die Bilder dürfen unter Nennung des Urhebers frei verwendet werden. Wir danken den jeweiligen Urhebern für die Bereitstellung ihrer Werke.
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Legal;